import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuditorForm, SoseApplication, SoseApplicationDto, SoseOverviewDto } from 'src/app/models/auditor-form.model';
import { SoseApplicationInterface } from './sose-application.interface';
import { SoseApplicationAttestationSection } from 'src/app/models/sose-application-attestation-section-model';


@Injectable({ providedIn: 'root' })
export class SoseApplicationService implements SoseApplicationInterface {

  constructor(private httpClient: HttpClient) { }

  SaveSoseApplication(request: SoseApplication): Observable<string> {
    return this.httpClient.post<string>(environment.apiBaseUrl + `soseApplication/SaveSoseApplication`, request);
  }

  GetSoseApplication(soseApplicationId: string): Observable<SoseApplication> {
    return this.httpClient.get<any>(`${environment.apiBaseUrl}soseApplication/GetSoseApplicationByApplicationId/${soseApplicationId}`);
  }

  GetSoseApplicationAttestationSections(): Observable<SoseApplicationAttestationSection[]> {
    return this.httpClient.get<SoseApplicationAttestationSection[]>(environment.apiBaseUrl + `soseApplication/GetSoseApplicationAttestationSections`);
  }

  SubmitSoseApplication(soseApplicationId: string): Observable<boolean> {
    return this.httpClient.get<any>(environment.apiBaseUrl + `soseApplication/SubmitSoseApplication/${soseApplicationId}`);
  }

  SaveSoseProgramLatestPageIndex(soseApplicationId: string, latestPageIndex: number) {
    return this.httpClient.get<any>(environment.apiBaseUrl + 'soseApplication/SaveSoseProgramLatestPageIndex/' + soseApplicationId + '/' + latestPageIndex);
  }

  GetEmployerSoseApplications(): Observable<SoseApplicationDto[]> {
    return this.httpClient.get<SoseApplicationDto[]>(environment.apiBaseUrl + `soseApplication/GetEmployerSoseApplications`);
  }

  GetSoseOverviewInformation(soseApplicationId: string): Observable<SoseOverviewDto> {
    return this.httpClient.get<SoseOverviewDto>(environment.apiBaseUrl + `soseApplication/GetSoseOverviewInformation/${soseApplicationId}`);
  }
}
